import React from "react";
import BaseButton, { ButtonProps } from "@material-ui/core/Button";

interface Props extends ButtonProps {
  eventProps?: object;
  [k: string]: any;
}

const Button = ({ eventProps, ...rest }: Props): JSX.Element => (
  <BaseButton
    // @ts-expect-error
    onClick={eventProps && ((): void => gtag("event", "click", eventProps))} // eslint-disable-line no-undef
    {...rest}
  />
);

export default Button;
